import { Box, Typography } from "@mui/material";
import React, { useCallback, useRef, useState } from "react";
import { useEffect } from "react";
import { getTrainList } from "../../../../api/area";
import adultEducation from "../../../../assets/image/adultEducation.png";
import SearchInput from "../../../project/searchInput";
import TableTrainList from "../../table/tableTrainList";

export default function AdultEducation({ dataArea }) {
  const [rowData, setRowData] = useState([]);
  const [rowDataAdult, setRowDataAdult] = useState([]);
  // console.log(rowData);
  const [valueSearch, setValueSearch] = useState();
  const gridRef = useRef();
  const gridRef2 = useRef();
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
    gridRef2.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);
  useEffect(() => {
    if (dataArea) {
      getTrainList(
        dataArea[0]?.areas[0]?.id,
        "?justAdult=true&justNotTrained=true"
      )
        .then((x) => setRowData(x))
        .catch((z) => console.log(z));
      getTrainList(
        dataArea[0]?.areas[0]?.id,
        "?justAdult=true&justTrained=true"
      )
        .then((x) => setRowDataAdult(x))
        .catch((z) => console.log(z));
    }
  }, [dataArea]);

  const handlePatientClick = () => {
    getTrainList(
      dataArea[0]?.areas[0]?.id,
      "?justAdult=true&justNotTrained=true"
    )
      .then((x) => setRowData(x))
      .catch((z) => console.log(z));
    getTrainList(dataArea[0]?.areas[0]?.id, "?justAdult=true&justTrained=true")
      .then((x) => setRowDataAdult(x))
      .catch((z) => console.log(z));
  };
  return (
    <Box>
      <>
        {!rowData?.length >= 1 && !rowDataAdult?.length >= 1 ? (
          <Box
            height="80vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <img src={adultEducation} style={{ marginTop: "50px" }} />
          </Box>
        ) : (
          <>
            <Box mt="30px" mb="10px" />
            <SearchInput
              type="text"
              id="filter-text-box"
              onInput={onFilterTextBoxChanged}
              value={valueSearch}
              onChange={(e) => setValueSearch(e.target.value)}
              mb="5px"
              // mr="20px"
            />
            <Typography
              my="20px"
              color="#127A92"
              fontSize="18px"
              fontWeight="bold"
            >
              جدول بیماران بزرگسال پذیرش نشده
            </Typography>
            <TableTrainList
            handlePatientClick={handlePatientClick}
              gridRef={gridRef}
              areaId={dataArea[0]?.areas[0]?.id}
              rowData={rowData}
              setRowData={setRowData}
            />
            <Typography
              my="20px"
              color="#127A92"
              fontSize="18px"
              fontWeight="bold"
            >
              جدول بیماران بزرگسال پذیرش شده
            </Typography>
            <TableTrainList
            handlePatientClick={handlePatientClick}
              gridRef={gridRef2}
              areaId={dataArea[0]?.areas[0]?.id}
              rowData={rowDataAdult}
              setRowData={setRowDataAdult}
            />
          </>
        )}
      </>
    </Box>
  );
}
